/**
 * Checking if given element is the last one in the array.
 *
 * @param {array} array array of elements, HTMLCollection.
 * @param {(string|string[])} el array of elements, HTMLCollection.
 * @return {boolean} true|false if element is the last one in the array.
 */
export function isLast(array, el) {
  return array[array.length - 1] === el;
}
